export default __webpack_public_path__ + "static/media/calendar.a954a644.svg";